<template>
    <div>
        <Row style="padding:5px" v-for="(item,index) in address" :key="index">
            <i-col span="24">
                <h4><a @click="changeMap(item.code)" :class="(defaultCity===item.code)? 'active':''">{{item.name}}</a></h4>
                <ul>
                    <li><strong>地址 </strong> {{item.address}}</li>
                    <li><strong>电话 </strong> {{item.phone}}</li>
                </ul>
            </i-col>
        </Row>

        <bmap :center-point="defaultCenterPoint"></bmap>
    </div>
</template>

<script>
import bmap from '@/components/bmap.vue'

export default {
  name: 'contact',
  components: {
    bmap
  },
  data () {
    return {
      defaultCenterPoint: {},
      defaultCity: '成都',
      address: [
        { code: '成都', name: '成都公司', address: '成都市高新区天府软件园B3栋', phone: '+028 85939933', center: { lng: 104.076673, lat: 30.550755 } },
        { code: '上海', name: '上海办事处', address: '上海市浦东新区丁香路1089号中邦风雅颂', phone: '+86 18602108803', center: { lng: 121.56175, lat: 31.23443 } },
        { code: '青岛', name: '青岛公司', address: '青岛市市北区黑龙江中路450号地铁大厦A座712室', phone: '+86 13853176770', center: { lng: 120.388306, lat: 36.070431 } },
        { code: '厦门', name: '厦门办事处', address: '厦门市思明区前埔工业园61号万物社C302至C307', phone: '+86 13328320519', center: { lng: 118.182506, lat: 24.488134 } }
      ]
    }
  },
  created () {
    this.defaultCenterPoint = this.address[0].center
  },
  methods: {
    changeMap (citycode) {
      this.defaultCity = citycode

      const chooseCity = this.address.find(x => x.code === citycode)
      this.defaultCenterPoint = chooseCity.center
    }
  }
}
</script>
